const Section = ({extraClasses = '', extraContainerClasses = '', withoutContainer=false, children}) => {

    const Container = withoutContainer ? children : <div className={`content-contain ${extraContainerClasses}`}>{children}</div> ;
    return (
        <div className={`section ${extraClasses}`}>
            {Container}
        </div>
    );
}

export default Section;